import { USER_GROUP } from "vacv-components";

export enum SearchType {
  Package = "packages",
  Hotels = "hotels",
  Link = "link",
  FlightAndHotel = "flight_hotel",
}

export enum Locales {
  FR = "fr",
  EN = "en",
}

export enum forModifySearch {
  TRUE = "true",
  FALSE = "false",
}

export type Translations = Record<Locales, string>;

export type LinkAttributes = {
  linkTo?: Translations & { newTab?: boolean };
};

export type BaseAttributes = {
  label: Translations;
  selected?: boolean;
} & LinkAttributes;

export type TabConfig = BaseAttributes & {
  id: string;
  searchType: SearchType;
  selected?: boolean;
  audience?: Audiences;
  forModifySearch?: forModifySearch;

  // these are added by searchSpaConfig
  linkHref?: string;
  linkTarget?: string;
  linkLabel?: string;
  minDate: string; // yyyy-MM-dd format
  maxDate: string;

  minStay?: number; // TODO: 20250501 - CC - To be externalized at Magnolia side.
  isModifySearch?: boolean;
};

export type AudienceAttributes = {
  label?: Translations;
  display?: string;
} & LinkAttributes;

export type Audiences = {
  [value in USER_GROUP]: AudienceAttributes;
};
